import { NavLink, Link } from "react-router-dom";

function Header() {
  return (
    <header className="site-header">
      <Link to="/" className="brand">
        <img src="/images/logo.png" alt="R&Do Ltd." />
      </Link>

      <nav className="nav">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/projects">Projects</NavLink>
        <NavLink to="/clients-and-synergies">Clients & Synergies</NavLink>
        <NavLink to="/news">News</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </nav>
    </header>
  );
}

export default Header;